import React, {useEffect, useState} from "react";
import YourInside from "./human/head";
import {Button, Offcanvas} from "react-bootstrap";
import {environment} from "./environment";

function Human({result}) {
    const showLink = environment().showLink;

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [svgBackground, setSvgBackground] = useState('#000');
    const [background, setBackground] = useState('#fff');

    const [data, setData] = useState({
        brain: 'n',
        heart: 'n',
        body: 'n',
        rightHand: 'n',
        leftHand: 'n',
        legs: 'n',
        hair: 'n',
        eye: 'n',
        ears: 'n',
        nose: 'n',
        lips: 'n',
    })

    useEffect(() => {
        if (result) {
            setData({
                brain: convertToSize(result.brain),
                hair: convertToSize(result.hair),
                heart: convertToSize(result.heart),
                body: convertToSize(result.waist),
                rightHand: convertToSize(result.rightHand),
                leftHand: convertToSize(result.leftHand),
                legs: convertToSize(result.rightLeg),
                eye: convertToSize(result.eye),
                ears: convertToSize(result.ears),
                nose: convertToSize(result.nose),
                lips: convertToSize(result.lip),
            })
        }
    }, [result])

    const convertToSize = (size) => {
        switch (size) {
            case 1:
                return 'vs';
            case 2:
                return 's';
            case 3:
                return 'n';
            case 4:
                return 'b';
            case 5:
                return 'vb';
        }
    }

    const convertToString = (size) => {
        switch (size) {
            case 'vs':
                return 1;
            case 's':
                return 2;
            case 'n':
                return 3;
            case 'b':
                return 4;
            case 'vb':
                return 5;
        }
    }

    const toggle = () => {
        if (svgBackground === '#000') {
            setSvgBackground('#fff');
            setBackground('#000');
        } else {
            setSvgBackground('#000');
            setBackground('#fff');
        }
    }

    return (
        <>
            <YourInside data={data}
                        background={background}
                        svgBackground={svgBackground}/>

            <div className={'position-fixed bottom-0 start-50 translate-middle-x mb-5 w-100 text-center px-3'}>
                <Button variant="primary" size={'lg'} className={'rounded-pill w-100 mb-3 animate__animated animate__heartBeat animate__infinite'} onClick={handleShow}>
                    توضیحات
                </Button>
                <div>
                    <Button variant={svgBackground === '#000' ? 'light' : 'dark'}
                            className={'ms-3 rounded-pill px-4'}
                            onClick={toggle}>
                        {
                            svgBackground === '#000' ? <>زمینه سفید</> : <>زمینه مشکی</>
                        }
                    </Button>
                    <a className={'btn btn-danger rounded-pill ms-3'} href={'/'}>
                        پایان
                    </a>
                </div>
            </div>

            <Offcanvas show={show} onHide={handleClose}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>توضیحات</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className={'py-3'}>
                        <p><i className={'bi bi-stars text-warning'}></i> آدم درونت رو دیدی؟ حالا منتظر باش تا رازش رو برات بگیم!
                        <i className={'bi bi-stars text-warning'}></i>
                        </p>

                        <p>درود هم‌ریشه <i className={'bi bi-hearts text-danger'}></i></p>

                       <p>
                           حالا که تصویر آدم درونت رو گرفتی، وقتشه که بفهمی این تصویر دقیقاً داره چی درباره‌ی تو می‌گه!
                       </p>

                        <p><i className={'bi bi-check-square-fill text-success'}></i> کدوم بخش‌های شخصیتت قوی و متعادله؟</p>
                        <p> <i className={'bi bi-check-square-fill text-success'}></i> کجاها نیاز به تغییر و بهبود داره؟</p>
                        <p><i className={'bi bi-check-square-fill text-success'}></i> و چطور می‌تونی این آدم درونت رو به نسخه‌ای زیباتر و قوی‌تر تبدیل کنی؟</p>

                        <p>
                            <i className={'bi bi-bell-fill text-warning'}></i> منتظر ارتباط تیم تخصصی دکتر بیتا حسینی باش!
                        </p>
                        <p>
                            کارشناسان ما به زودی باهات ارتباط می‌گیرن تا تحلیل اختصاصی تصویرت رو بهت بگن.
                        </p>
                    </div>

                    {
                        showLink ? <div className={'py-3'}>
                            <a className={'btn btn-primary w-100 rounded-pill'}
                               target={'_blank'}
                               href={'https://shop.drbitahosseini.com/custom/pay?token=MTczODg0Njk1MDk2NDoxOTM6MTczODg0Njk1MDk2NA=='}>
                                لینک پرداخت
                            </a>
                        </div> : null
                    }

                    {
                        data ? <ul className={'list-group'}>
                            <li className={'list-group-item yasi text-center text-white'}>
                                توضیحات نیم رخ درون شما
                            </li>
                            <li className={'list-group-item'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>مغز</div>
                                    <div className={'ms-auto'}>
                                        {convertToString(data.brain)}
                                    </div>
                                </div>
                            </li>
                            <li className={'list-group-item'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>موی، ابرو و مژه</div>
                                    <div className={'ms-auto'}>
                                        {convertToString(data.hair)}
                                    </div>
                                </div>
                            </li>
                            <li className={'list-group-item'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>قلب</div>
                                    <div className={'ms-auto'}>
                                        {convertToString(data.heart)}
                                    </div>
                                </div>
                            </li>
                            <li className={'list-group-item'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>کمر</div>
                                    <div className={'ms-auto'}>
                                        {convertToString(data.body)}
                                    </div>
                                </div>
                            </li>
                            <li className={'list-group-item'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>دست راست</div>
                                    <div className={'ms-auto'}>
                                        {convertToString(data.rightHand)}
                                    </div>
                                </div>
                            </li>
                            <li className={'list-group-item'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>دست چپ</div>
                                    <div className={'ms-auto'}>
                                        {convertToString(data.leftHand)}
                                    </div>
                                </div>
                            </li>
                            <li className={'list-group-item'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>پا</div>
                                    <div className={'ms-auto'}>
                                        {convertToString(data.legs)}
                                    </div>
                                </div>
                            </li>
                            <li className={'list-group-item'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>چشم</div>
                                    <div className={'ms-auto'}>
                                        {convertToString(data.eye)}
                                    </div>
                                </div>
                            </li>
                            <li className={'list-group-item'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>گوش</div>
                                    <div className={'ms-auto'}>
                                        {convertToString(data.ears)}
                                    </div>
                                </div>
                            </li>
                            <li className={'list-group-item'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>بینی</div>
                                    <div className={'ms-auto'}>
                                        {convertToString(data.nose)}
                                    </div>
                                </div>
                            </li>
                            <li className={'list-group-item'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>لب</div>
                                    <div className={'ms-auto'}>
                                        {convertToString(data.lips)}
                                    </div>
                                </div>
                            </li>
                        </ul> : null
                    }
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}

export default Human;
